<dw-ui-dialog-box [title]="'Doc::GenerateSupplierOrders'" (saveFn)="save()" [displayCancel]="false">
  <form [formGroup]="form">
    <dw-ui-table [isSelectable]="false" [canAdd]="false" formArrayName="supplierOrders">
      <ng-container header>
        <th>{{ 'Doc::OpenOrder:GroupingKey' | abpLocalization }}</th>
        <th>{{ 'Doc::SupplierPurchaseOrder' | abpLocalization }}</th>
      </ng-container>

      @for (
        supplierOrderControl of supplierOrdersArray.controls;
        track supplierOrderControl;
        let i = $index
      ) {
        <dw-ui-table-row [formGroupName]="i" [data]="supplierOrderControl">
          <td>
            <div class="d-flex flex-column small text-muted">
              <div>
                <strong>{{ 'Contact::Supplier' | abpLocalization }}:</strong>
                {{ selectedSupplierOrderByGroupKey()[i]?.groupKey?.supplierCode }}
              </div>
              <div>
                <strong>{{ 'Contact::Customer' | abpLocalization }}:</strong>
                {{ selectedSupplierOrderByGroupKey()[i]?.groupKey?.customerCode }}
              </div>
              <div>
                <strong>{{ 'Doc::CustomerSalesPurchase' | abpLocalization }}:</strong>
                {{ selectedSupplierOrderByGroupKey()[i]?.groupKey?.customerOrderDisplayNumber }}
              </div>
            </div>
          </td>
          <td>
            <ng-select
              class="form-control"
              [items]="selectedSupplierOrderByGroupKey()[i]?.supplierOrders || []"
              bindLabel="displayNumber"
              bindValue="id"
              formControlName="id"
            >
            </ng-select>
          </td>
        </dw-ui-table-row>
      }
    </dw-ui-table>
  </form>
</dw-ui-dialog-box>
